// eslint-disable-next-line @typescript-eslint/typedef
export const FragmentsFilterEvents = {
  fragmentsReleased: 'fragmentsFilter.fragmentsReleased',
  problemDetected: 'fragmentsFilter.problemDetected',
} as const;
